import type { FC } from 'react';

import { useUITheme } from '@crehana/compass.ui';
import { useTranslation } from '@crehana/i18n';
import Bulb from '@crehana/icons/outline/Bulb';
import ExternalLink from '@crehana/icons/outline/ExternalLink';

import { HELP_URL } from './constants';
import { BeautyButton, Title, WrapperLinks } from './HelperLinks.styles';
import type { HelperLinksProps } from './types';

const HelperLinks: FC<HelperLinksProps> = ({ handleTour }) => {
  const { t } = useTranslation();
  const { isDark } = useUITheme();

  return (
    <WrapperLinks>
      <Title className="font-body4" isDark={isDark}>
        {t('HELPER_LINK_TITLE')}
      </Title>
      <BeautyButton
        className="font-subtitle4"
        isDark={isDark}
        onClick={() => handleTour(true)}
      >
        <Bulb color="currentColor" size={16} />
        {t('HELPER_LINK_GUIDE')}
      </BeautyButton>
      <BeautyButton
        className="font-subtitle4"
        isDark={isDark}
        href={HELP_URL}
        target="_blank"
      >
        <ExternalLink color="currentColor" size={16} />
        {t('HELPER_LINK_QUESTIONS')}
      </BeautyButton>
    </WrapperLinks>
  );
};

export default HelperLinks;
